// extracted by mini-css-extract-plugin
export default {"stacked":"FormButton_stacked__lBjto","btn":"FormButton_btn__Yz07C","btnLoading":"FormButton_btnLoading__ru-hq"};